import UsersChart from './UsersChart';

export default UsersChart;
